import { cloneData } from './cloneData';
export function highlighting(data) {
    data = cloneData(data);
    for (var i = 0; i < 81; i += 9) {
        if (horizontal(data, i)) {
            for (var j = i; j < i + 9; j++) {
                data[j].highlighting = true;
            }
        }
    }
    for (var i = 0; i < 9; i++) {
        if (vertical(data, i)) {
            for (var j = i; j < i + 73; j += 9) {
                data[j].highlighting = true;
            }
        }
    }
    for (var _i = 0, _a = [0, 3, 6, 27, 30, 33, 54, 57, 60]; _i < _a.length; _i++) {
        var i = _a[_i];
        if (cube(data, i)) {
            for (var _b = 0, _c = [0, 1, 2, 9, 10, 11, 18, 19, 20]; _b < _c.length; _b++) {
                var k = _c[_b];
                data[i + k].highlighting = true;
            }
        }
    }
    return data;
}
function horizontal(data, start) {
    for (var i = start; i < start + 9; i++) {
        if (!data[i].value && !data[i].shadow) {
            return false;
        }
    }
    return true;
}
function vertical(data, start) {
    for (var i = start; i < start + 73; i += 9) {
        if (!data[i].value && !data[i].shadow) {
            return false;
        }
    }
    return true;
}
function cube(data, start) {
    for (var _i = 0, _a = [0, 1, 2, 9, 10, 11, 18, 19, 20]; _i < _a.length; _i++) {
        var k = _a[_i];
        var i = start + k;
        if (!data[i].value && !data[i].shadow) {
            return false;
        }
    }
    return true;
}
